import BaseService from '../../services/BaseService';

class HelpService extends BaseService{
  
}

export default new HelpService('health_backend','helps');